type ContactsData = {
  emails: {
    [key: string]: Array<string>;
  };
  phones: {
    [key: string]: Array<string>;
  };
};

type Mapping = {
  [key: string]: string;
};
const mapping: Mapping = {
  RN: 'Роснефть',
  RZD: 'РЖД',
  OS: 'Общая секция',
  SALE: 'Продажа имущества',
  UVS: 'УВС',
  GB: 'Газпром бурение',
  IRAG: 'ИРАО',
  MARKET: 'Интернет-Магазин',
  GZ: 'Госзакупки',
};

const getSourceEmailsAndPhones = (res?: ContactsData) => {
  if (!res) {
    return '';
  }
  const result = Object.values(res).reduce((acc: any, cur: any) => {
    const data = Object.values(cur).flat();
    const mappingData = data.map((el: any) => mapping[el]);

    return [...acc, ...mappingData];
  }, []);

  return Array.from(new Set(result)).join(', ');
};
export default getSourceEmailsAndPhones;
